/** @format */

/// Example taken from: https://experienceleague.adobe.com/docs/target/using/implement-target/client-side/at-js-implementation/deploy-at-js/target-atjs-single-page-application.html?lang=en
const triggerTargetView = (viewName = 'default-view'): void => {
  // Validate if the Target Libraries are available on your website
  if (
    window &&
    typeof window.adobe !== 'undefined' &&
    window.adobe.target &&
    typeof window.adobe.target.triggerView === 'function'
  ) {
    window.adobe.target.triggerView(viewName);
  }
};

export { triggerTargetView };
